import { Injectable } from '@angular/core';
import { BlobToPdfService } from './blob-to-pdf.service';
import { Core } from '@pdftron/webviewer';

@Injectable({
  providedIn: 'root'
})
export class PdfPageService {

  // private get internalWV(): HTMLIFrameElement | null {
  //   const wvElement = document.getElementById('webviewerInternal');
  //   return wvElement !== null ? wvElement.querySelector('iframe') as HTMLIFrameElement : null;
  // }

  // private get internalPDFNet(): any | null {
  //   return this.internalWV !== null ? (this.internalWV.contentWindow as any).PDFNet : null;
  // }

  private get PDFNet(): typeof Core.PDFNet {
    return (window as any).Core.PDFNet;
  }

  constructor(
    private blobToPdfSvc: BlobToPdfService) { }

  public async extractPagesFromDocument(start, end, title, doc): Promise<File | null> {
    // remove pages before start index. Array changes, so keep deleting page 1.
    for (let pageCounter = 1; pageCounter < start; pageCounter++) {
      const itr = await doc.getPageIterator(1);
      doc.pageRemove(itr);
    }

    // get document new pageCount
    let pageCount = await doc.getPageCount();

    // Keep removing last pages until you end up with the requested amount of pages.
    while (pageCount > end - start + 1) {
      const itr = await doc.getPageIterator(pageCount);
      doc.pageRemove(itr);
      pageCount--;
    }

    // Reconstruct file. Skip this and Webviewer will be unable to read the file.
    if (this.PDFNet.SDFDoc) {
      const docbuf = await doc.saveMemoryBuffer(this.PDFNet.SDFDoc.SaveOptions.e_linearized);
      return await this.blobToPdfSvc.convertArrayToFile(docbuf, title);
    }
    return null;
  }
}
